import React, { useEffect, useState } from 'react';

const initMap = () => {
  const naver = window.naver;
  return new naver.maps.Map('naver-map', {
    zoomControl: true,
    zoomControlOptions: {
      style: naver.maps.ZoomControlStyle.LARGE,
      position: naver.maps.Position.TOP_RIGHT
    },
    mapTypeControl: true,
    center: { lat: 37.659101, lng: 127.059603 },
    zoom: 13
  });
};

const Map2 = () => {
  const [mapType, setMapType] = useState("naver");
  const [map, setMap] = useState(null);

  useEffect(() => {
    setMap(initMap());
  }, []);

  useEffect(() => {
    (map !== null) && window.naver.maps.Event.once(map, 'init', () => afterPropertiesSetMap(map));
  }, [map]);

  const afterPropertiesSetMap = (map) => {
    const naver = window.naver;
    new naver.maps.drawing.DrawingManager({
      map: map,
      drawingControl: [
        naver.maps.drawing.DrawingMode.HAND,
        naver.maps.drawing.DrawingMode.RECTANGLE,
        naver.maps.drawing.DrawingMode.ELLIPSE,
        naver.maps.drawing.DrawingMode.POLYLINE,
        naver.maps.drawing.DrawingMode.ARROWLINE,
        naver.maps.drawing.DrawingMode.POLYGON,
        naver.maps.drawing.DrawingMode.MARKER
      ],
      drawingControlOptions: {
        position: naver.maps.Position.TOP_CENTER,
        style: naver.maps.drawing.DrawingStyle.HORIZONTAL
      }
    });
  };

  const onChangeMapType = (e) => {
    const mapType = e.target.value;
    setMapType(mapType);
  };

  return (
    <>
      <div style={{ display: "none" }}>
        <select onChange={onChangeMapType}>
          <option value={"naver"}>naver</option>
          <option value={"kakao"}>kakao</option>
          <option value={"google"}>google</option>
        </select>
      </div>
      {mapType === "naver" && <div id="naver-map" style={{ height: window.innerHeight }}></div>}
      {mapType === "kakao" && <div id="kakao-map" style={{ height: window.innerHeight }}></div>}
      {mapType === "google" && <div id="google-map" style={{ height: window.innerHeight }}></div>}
    </>
  );
}

export { Map2 };
